import { useState } from "react";
import Citydata from "../data/data1.json";

function PackagesSection({ city }) {

  const [openSections, setOpenSections] = useState({
    Standard: null,
    Premium: null,
    Luxury: null,
  });

  // ✅ Find city safely
  const selectedCitys = Citydata.find(
    (c) => c.city_name === city
  );

  // ✅ Toggle
  const toggleSection = (pkg, section) => {
    setOpenSections((prev) => ({
      ...prev,
      [pkg]: prev[pkg] === section ? null : section,
    }));
  };

  // ✅ Data
  const data = {
    Standard: ["Design", "Structure", "Flooring and dado","Doors and Windows","Plumbing accessories","Painting","Electrical","Plumbing","Railing and Handrails"],
    Premium: ["Design", "Structure", "Flooring and dado","Doors and Windows","Plumbing accessories","Painting","Electrical","Plumbing","Railing and Handrails"],
    Luxury: ["Design", "Structure", "Flooring and dado","Doors and Windows","Plumbing accessories","Painting","Electrical","Plumbing","Railing and Handrails"],
  };

  const designList = [
    "Digital plot and contour survey",
    "2D floor plan & 3D Elevation",
    "GFC - Good for construction drawings",
    "RCC drawings",
    "Electrical & Plumbing drawings",
  ];

  // ✅ Safe function (NO ERROR EVER)
  const getRate = (pkg) => {
    return selectedCitys?.packages?.[pkg.toLowerCase()]?.rate_per_sqft_ex_gst;
  };

  return (
    <section className="bg-[#f1e7ff] font-poppins py-[80px] px-6 text-center">
      <div className="flex flex-wrap justify-center gap-6">

        {Object.keys(data).map((pkg) => {
          const rate = getRate(pkg);

          return (
            <div
              key={pkg}
              className="bg-white rounded-xl p-6 w-[360px] text-left shadow-sm"
            >
              <h3 className="text-[25px] font-semibold mb-4">{pkg}</h3>

              {/* ✅ SHOW ONLY IF RATE EXISTS */}
              {rate && (
                <>
                  <h3 className="text-[16px] font-semibold mb-1">
                    ₹{rate}
                  </h3>
                  <p className="mb-3 text-[14px]">
                    Per sq.ft (Ex GST)
                  </p>
                </>
              )}

              {data[pkg].map((section, index) => (
                <div key={index} className="border-t py-3">

                  {/* HEADER */}
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => toggleSection(pkg, section)}
                  >
                    <div className="flex items-center gap-2">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-200 text-sm">
                        {openSections[pkg] === section ? "−" : "+"}
                      </span>
                      <h4 className="font-medium">{section}</h4>
                    </div>
                  </div>

                  {/* CONTENT */}
                  {openSections[pkg] === section && (
                    <ul className="mt-3 ml-8 list-disc text-sm text-gray-600 space-y-2">

                      {section === "Design" &&
                        designList.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}

                      {section !== "Design" && (
                        <li>Details coming soon...</li>
                      )}

                    </ul>
                  )}

                </div>
              ))}
            </div>
          );
        })}

      </div>
    </section>
  );
}

export default PackagesSection;